import React, { useState, useEffect } from 'react';
import { Button,App ,Modal} from 'antd';
import styles from './index.module.scss';
import { useParams, useSearchParams, useNavigate,useLocation } from 'react-router-dom';
import { reportArrival, saveOrderStatus, getEmergencyServiceById } from '@/api/order';
import OrderDialogCar, { OrderDialogOrder, OrderDialogMode } from '@/components/OrderDialogCar/OrderDialogCar';
import { OrderItem } from '@/pages/YourTownloop/Subroute/PostOrders/order';
import dayjs from 'dayjs';
import { createChatRoom } from '@/api/message';
import { useAppSelector } from '@/store/hooks';

interface YourTownloopOrdersListProps {
  orderItem: OrderItem;
  getId?: (id: string, action: string) => void;
  type?: 'ride' | 'delivery';
  isPoster?: boolean;//true是订单发布者 false是司机接单人
}

const CarpoolServiceDetail: React.FC<YourTownloopOrdersListProps> = ({ orderItem, getId, type,isPoster=true }) => {
  const navigate = useNavigate();
  const { message } = App.useApp();
  const params = useParams(); // 获取URL参数

  const [searchParams] = useSearchParams();
  const paramsLocation = useLocation(); // 获取URL参数
  // 紧急程度
  const UrgencyLevel = useAppSelector((state) => state.common.UrgencyLevel);
  const [UrgencyLevelName, setUrgencyLevelName] = useState<string>('')
  const [checkInFlag, setCheckInFlag] = useState<boolean>(true)
  const [confirmArrivalFlag, setConfirmArrivalFlag] = useState<boolean>(true)
  // 辅助函数：格式化日期
  const formatDate = (date: string | dayjs.Dayjs | undefined): string => {
    if (!date) return '';
    if (typeof date === 'string') return date;
    return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
  };

  // 转换OrderItem为OrderDialogOrder兼容的格式
  const convertToDialogOrder = (data: OrderItem): OrderDialogOrder => {
    return {
      ...data,
      departure_date: data.departure_date,
      pickup_time: data.pickup_time,
      expected_delivery_time: data.expected_delivery_time,
    };
  };

 

  const [mapUrl, setMapUrl] = useState<string>('')



  //是否是送货 - 优先使用传入的type，否则从URL参数获取
  const isDelivery = type === 'delivery';

  const currentData:any = orderItem ;
  const ConfirmArrival = () => { 
    console.log('ConfirmArrival');
  };
  // 联系车主
  const contactTheMaster = () => {
    console.log('contactTheMaster');
    createChatRoom({ member_id: currentData?.partner_user_id || '' }).then((res) => {
      if (res.code == 200) {
        navigate(`/chatList?chatRoomId=${res.data.room_id}`);
      } else {
        message.error(res.message);

      }
    });
  };

  // 确认订单
  const confirmOrder = () => {
    //是否确认订单
    Modal.confirm({
      title: 'Confirm the order',
      content: 'Are you sure you want to confirm the order?',
      onOk: async () => {
        console.log('confirmOrder');
        const productsToOrder = [{
          product_id: "PROD-3b56545e11561764313798029",
          type: 2,  // 1预付款  2尾款
          product_sku_id: "SN-763c990a-9fec-4fc0-847e-9b909d8435df",
        }];
        const encodedData = btoa(JSON.stringify(productsToOrder));
        navigate(`/emergency_service_ordering?products_to_order=${encodedData}`);
      }
    });
  };
  const _reportArrival = () => {
    reportArrival({latitude:currentData.latitude,longitude:currentData.longitude,emergency_service_id:currentData.emergency_service_id}).then((res) => { 

    });
  }
  // 竞价和一口价弹窗

  useEffect(() => {
    const start = currentData.starting_point_address + ',' + currentData.starting_point_city + ',' + currentData.starting_point_state;
    const destination = currentData.destination_point_address + ',' + currentData.destination_point_city + ',' + currentData.destination_point_state;
    //debugger
    const mapQuery = encodeURIComponent(`${start} to ${destination}`);
    const mapUrl2 = `https://www.google.com/maps?output=embed&q=${mapQuery}`;
    setMapUrl(mapUrl2);
  }, [currentData])



  useEffect(() => {
    const obj:any = UrgencyLevel.find(item => item.value === currentData?.urgency_level)
    setUrgencyLevelName(obj?.label)
    _reportArrival()
    console.log('Component mounted========',currentData,obj);
  }, [currentData])



  return (
    <div className={styles['detail-page']}>
      <div className={styles['info-card']}>
        <ul className={styles['route-list']}>
          { paramsLocation.pathname === "/yourtownloop/serviceorders" ?
            <li>
              <span className={`${styles['label-strong']} ${styles['label-check-tr']}`}>Order Tracking</span>                                     
                <Button
                  className={ `${checkInFlag}?${styles['btn-disabled']}:${styles['btn-primary-tr']}`}
                  onClick={() => ConfirmArrival()}
                  disabled={checkInFlag}
                >Check-In</Button>          
            </li> :  
            <li>
              <span className={`${styles['label-strong']} ${styles['label-strong-tr']}`}>Order Tracking</span>                      
              <Button
              className={ `${checkInFlag}?${styles['btn-disabled']}:${styles['btn-primary-tr']}`}
              style={{minWidth:isPoster?"160px":"230px"}}
              disabled={confirmArrivalFlag}
              onClick={() => ConfirmArrival()}
            >Confirm Arrival</Button>          
            </li>        
          }

          <li>
            <span className={styles['label-strong']}>Appliance Repair</span>
          </li>
        </ul>

        <div className={styles['miles-row']}>
          <span className={styles['dot']}></span>
          {currentData.distance || 2.5} Miles From You
        </div>

        <div className={styles['divider']} />

        {/* 拼车送人 */}
        {
          isPoster && (
            <>
              <div className={styles['row']}>
                <span className={styles['label']}>Order Numbe:</span>
                <span className={styles['value']}>{formatDate(currentData.departure_date)}</span>
              </div>
              <div className={styles['row']}>
                <span className={styles['label']}>Phone:</span>
                <span className={styles['value']}>{currentData.phone} People</span>
              </div>
              <div className={styles['row']}>
                <span className={styles['label']}>address:</span>
                <span className={styles['value']}>{currentData.address}</span>
              </div>
              <div className={styles['row']}>
                <span className={styles['label']}>Urgency Level:</span>
                <span className={styles['value']}>{UrgencyLevelName}</span>
              </div>

              <div className={styles['row']}>
                <span className={styles['label']}>Bidding Time:</span>
                <span className={styles['value']}>{currentData.notes}</span>
              </div>
              <div className={styles['row']}>
                <span className={styles['label']}>Problem Description:</span>
                <span className={styles['value']}>{currentData.problem_description}</span>
              </div>
              <div className={styles['row']}>
                <span className={styles['label']}>Image Upload:</span>
                <div className={styles['value']}>
                    <img
                      src={currentData.images[0].product_media_file_url}
                      alt="Product"
                      className={styles['product-image']}
                    />                  
                </div>
              </div>
            </>
          )
        }
        <div className={styles['price-row']}>
          <span className={styles['price-label']}>Price:</span>
          <span className={styles['price']}>${currentData.budget}</span>
        </div>
        { paramsLocation.pathname === "/yourtownloop/serviceorders" ?
          <div className={styles['actions']}>
            <Button
              className={styles['btn-outline']}
              style={{minWidth:isPoster?"160px":"230px"}}
              onClick={() => contactTheMaster()}
            >Contact Customer</Button>
            {/* 发布人确认订单 */}
            {
              isPoster && (
                <Button
                  className={styles['btn-primary']}
                  onClick={() => confirmOrder()}
                >Confirm Service</Button>
              )
            }            
          </div>:
          <div className={styles['actions']}>
            <Button
              className={styles['btn-outline']}
              style={{minWidth:isPoster?"160px":"230px"}}
              onClick={() => contactTheMaster()}
            >Contact the master</Button>
            {/* 发布人确认订单 */}
            {
              isPoster && (
                <Button
                  className={styles['btn-primary']}
                  onClick={() => confirmOrder()}
                >Confirm the order</Button>
              )
            }          
          </div>        
        }

      </div>

      <div className={styles['map-card']}>
        <iframe
          className={styles['map-iframe']}
          src={mapUrl}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="route-map"
        />
      </div>

      
    </div>
  );
};

export default CarpoolServiceDetail; 